<template>
    <div class="modal fade" id="editUser" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-edit-user modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal('#editUser')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pb-5 px-sm-4 pt-50">
                    <div class="text-center mb-2">
                        <h1 class="mb-1">Edit User Information</h1>
                        <a href="javascript:void(0)" hidden id="openTwoFactorAuthSmsModal" data-target="#twoFactorAuthSmsModal" data-toggle="modal">clicker</a>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="firstname">Firstname</label>
                                    <input type="text" class="form-control" placeholder="firstname" name="firstname" id="firstname" v-model="userStore.user.firstname">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="middle_name">Middlename</label>
                                    <input type="text" class="form-control" placeholder="Middlename" name="middle_name" id="middle_name" v-model="userStore.user.middle_name">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="lastname">Lastname</label>
                                    <input type="text" class="form-control" placeholder="Lastname" name="lastname" id="lastname" v-model="userStore.user.lastname">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" style="margin-bottom: 0px !important;">
                                    <label for="dob">Birth Date</label>
                                    <flat-pickr v-model="userStore.user.dob" :config="userStore.config"  class="form-control"></flat-pickr>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="address">Address</label>
                                    <input id="address" type="text" class="form-control" name="address" v-model="userStore.user.address" placeholder="Address">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="city">City</label>
                                    <input id="city" type="text" class="form-control" placeholder="City" v-model="userStore.user.city">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="state">State</label>
                                    <v-select
                                        :placeholder="State"
                                        v-model="userStore.user.state_id"
                                        :options="stateStore.states"
                                        :reduce="state => state.id"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="zipcode">Zipcode</label>
                                    <input id="zipcode" type="text" class="form-control" placeholder="zipcode" name="zipcode" maxlength="5" v-model="userStore.user.zipcode">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="email">E-mail</label>
                                    <input type="email" class="form-control" placeholder="Email" readOnly :value="userStore.user.email">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="ssn4">SSN
                                        <span class="ml-1">
                                            <a href="#" type="submit" data-toggle="modal" data-target="#ssn_modal">
                                                <strong> (Click Here To Update SSN)</strong>
                                            </a>
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="SSN"
                                        name="ssn4"
                                        id="ssn4"
                                        readOnly
                                        :value="mask(userStore.user.ssn, { unmaskedStartDigits: 0, unmaskedEndDigits: 4 } )"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="phone">
                                        <span class="ml-1">
                                            <a href="#" type="submit" data-toggle="modal" data-target="#twoFactorAuthSmsPhoneModal">
                                                <strong> (Click Here To Update Phone)</strong>
                                            </a>
                                        </span>
                                    </label>
                                    <input type="text" class="form-control" placeholder="phone" name="phone" id="phone" readOnly :value="userStore.user.phone">
                                </div>
                            </div>
                            <!-- <div class="col-md-3">
                                <div class="form-group">
                                    <label for="role">Role</label>
                                    <select class="form-control" id="role" name="role" v-model="role">
                                        <option :value="role.id" v-for="(role,index) in userStore.roles" :key="index">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->
                            <div class="col-12 d-flex flex-sm-row flex-column mt-2">
                                <button class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1 waves-effect waves-float waves-light" @click="updateUserData()">Save Changes</button>
                                <button class="btn btn-outline-secondary d-none d-sm-block waves-effect" @click="closeModal('#editUser')">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import vSelect from 'vue-select'
    import { useStateStore } from '../../stores/StateStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { closeModal, mask } from '../../utilities/_helpers'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    export default {
        components: {
            flatPickr,
            vSelect,
        },
        mounted() {
        },
        setup() {
            return {
                stateStore: useStateStore(),
                userStore: useUserStore(),
                closeModal: closeModal,
                mask: mask,
                config: {
                    wrap: true,
                    altFormat: 'j-m-Y',
                    altInput: true,
                    dateFormat: 'm-d-Y',
                },
            }
        },
        methods:{
            updateUserData(){
                if(
                    this.userStore.user.firstname  != ""
                    &&
                    this.userStore.user.lastname !=""
                    &&
                    this.userStore.user.middle_name !=""
                    &&
                    this.userStore.user.address !=""
                    &&
                    this.userStore.user.city !=""
                    &&
                    this.userStore.user.state_id !=""
                    &&
                    this.userStore.user.zipcode !=""
                    &&
                    this.userStore.user.dob !=""
                ){
                    const route = this.$router.resolve(
                    {
                        name: 'account-update'
                    }
                    );
                    axios.put(
                        route.href,
                        {
                            firstname: this.userStore.user.firstname ,
                            lastname : this.userStore.user.lastname,
                            middle_name: this.userStore.user.middle_name,
                            address: this.userStore.user.address,
                            city: this.userStore.user.city,
                            state_id: this.userStore.user.state_id,
                            zipcode: this.userStore.user.zipcode,
                            phone: this.userStore.user.phone,
                            dob: this.userStore.user.dob
                        }
                    ).then(({data})=>{
                        toastr.success(data.message,'success');
                        closeModal('#editUser');
                    }).catch(error=>{
                    toastr.error(error.message,'error');
                    });
                }else{
                    toastr.error('Please fill in all required fields','error');
                }
            },
        }
    }
</script>
